module.exports = __webpack_public_path__ + "static/media/d_vu.762dc414.png";